import { Button, Modal, Form, Row, Col, Radio, Typography } from "antd";
import Address from "CommonComponents/Address";
import OpenNotificationWithIcon from "CommonComponents/ResultNotification/Notification";
import AddressType from "features/Enums/AddressType";
import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
const { Title, Paragraph } = Typography;

function QuoteAddress(props) {
  const [form] = Form.useForm();
  const selectedLanguage = localStorage.getItem("selectedlanguage") || "fr-FR";
  const clients = useSelector((state) => state.clients.clientListById);
  const partner = useSelector((state) => state.clients.partnerClientById);
  const addressProvinces = useSelector(
    (state) => state.lookup.addressProvinces
  );
  const addressCountries = useSelector(
    (state) => state.lookup.addressCountries
  );
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [isEditable, setIsEditable] = useState(false);
  const [isFieldsEdited, setIsFieldsEdited] = useState(false);
  const [isAddressSectionVisible, setIsAddressSectionVisible] = useState(true);
  const hideEdit = props.hideEdit || false;

  let billing;
  let shipping;
  let other;

  if (partner && props.addressType == AddressType.BillingAddress.name) {
    billing = partner?.address?.find(
      (a) => a.addressType === AddressType.BillingAddress.id
    );
    shipping = partner?.address?.find(
      (a) => a.addressType === AddressType.CompanyAddress.id
    );
  } else {
    billing = clients?.address?.find(
      (a) => a.addressType === AddressType.BillingAddress.id
    );
    shipping = clients?.address?.find(
      (a) => a.addressType === AddressType.CompanyAddress.id
    );
    other = clients?.address?.filter(
      (a) => a.addressType === AddressType.AdditionalAddress.id
    );
  }

  const renderAddress = (addr) => {
    if (!addr) return "";
    const province = addressProvinces.find((p) => p.id === addr.provinceId);
    const country = addressCountries.find((c) => c.id === addr.countryId);

    const provinceName =
      selectedLanguage == "fr-FR"
        ? province?.provinceNameFr
        : province?.provinceNameEn;
    const countryName =
      selectedLanguage == "fr-FR"
        ? country?.countryNameFr
        : country?.countryNameEn;
    const parts = [
      addr.address1,
      addr.address2,
      addr.city,
      provinceName,
      countryName,
      addr.zip,
    ].filter(Boolean);

    return parts.join(", ");
  };

  const radioOptions = [];

  if (billing) {
    radioOptions.push({
      value: billing?.id,
      label: (
        <>
          <strong>
            {" "}
            {props.addressType == AddressType.BillingAddress.name ? (
              <>
                <FormattedMessage id="Common.Default" />{" "}
              </>
            ) : null}
            <FormattedMessage id="ClientDetails.BillingAddress" />
          </strong>
          <br />
          {renderAddress(billing)}
        </>
      ),
    });
  }

  if (shipping) {
    radioOptions.push({
      value: shipping?.id,
      label: (
        <>
          <strong>
            {props.addressType == AddressType.CompanyAddress.name ? (
              <>
                <FormattedMessage id="Common.Default" />{" "}
              </>
            ) : null}
            <FormattedMessage id="ClientDetails.DeliveryAddress" />
          </strong>
          <br />
          {renderAddress(shipping)}
        </>
      ),
    });
  }

  if (other?.length > 0) {
    other.forEach((addr, index) => {
      radioOptions.push({
        value: addr.id,
        label: (
          <>
            <strong>
              <FormattedMessage id="ClientDetails.OtherAddress" /> {index + 1}
            </strong>
            <br />
            {renderAddress(addr)}
          </>
        ),
      });
    });
  }

  const handleCancel = () => {
    setIsEditable(false);

    props.onCancel();
  };

  const handleEdit = () => {
    setIsEditable(true);
    setSelectedAddressId(null);

    form.setFieldsValue({
      [props.addressType]: {
        isAddressEdited: true,
        selectedAddressId: 0,
        address1: "",
        address2: "",
        city: "",
        provinceId: "",
        zip: "",
        countryId: "",
      },
    });
  };

  const handleUpdate = async () => {
    try {
      const values = await form.validateFields();
      const type = props.addressType;

      const updatedAddress = { ...values[type] };

      if (isEditable && isFieldsEdited) {
        updatedAddress.id = 0;
      }

      if (props.addressType == AddressType.BillingAddress.name) {
        props.setBillingAddress(updatedAddress);
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "Estimates.Notification.BillingAddressUpdatedSuccessfully"
        );
      } else if (props.addressType == AddressType.CompanyAddress.name) {
        props.setShippingAddress(updatedAddress);
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "Estimates.Notification.ShippingAddressUpdatedSuccessfully"
        );
      }

      props.onCancel();
    } catch (error) {
      console.log("Error validating form:", error);
      // OpenNotificationWithIcon(
      //   "error",
      //   "Common.Error",
      //   "",
      //   "Estimates.Notification.Anunexpectederroroccurredwhileupdatingaddress"
      // );
    }
  };

  useEffect(() => {
    if (selectedAddressId) {
      setIsEditable(false);
      let addr;
      if (partner && props.addressType == AddressType.BillingAddress.name) {
        addr = partner?.address?.find((a) => a.id === selectedAddressId);
      } else {
        addr = clients?.address?.find((a) => a.id === selectedAddressId);
      }

      if (addr) {
        form.setFieldsValue({
          [props.addressType]: {
            id: addr.id,
            address1: addr.address1,
            address2: addr.address2,
            city: addr.city,
            provinceId: addr.provinceId,
            zip: addr.zip,
            countryId: addr.countryId,
          },
        });
      }
    }
  }, [selectedAddressId]);

  useEffect(() => {
    let defaultAddress = null;
    if (partner && props.addressType == AddressType.BillingAddress.name) {
      setIsAddressSectionVisible(false);
    }

    if (props.addressType == AddressType.BillingAddress.name) {
      defaultAddress = props.billingAddress;
    } else if (props.addressType == AddressType.CompanyAddress.name) {
      defaultAddress = props.shippingAddress;
    }

    if (defaultAddress?.id) {
      if (partner && props.addressType == AddressType.BillingAddress.name) {
        setSelectedAddressId(defaultAddress.id);
      } else {
        const ClientAddressFound = clients?.address.find(
          (addr) => addr.id === defaultAddress.id
        );
        if (ClientAddressFound) {
          setSelectedAddressId(defaultAddress.id);
        } else {
          setIsEditable(true);
          form.setFieldsValue({
            [props.addressType]: {
              address1: defaultAddress.address1,
              address2: defaultAddress.address2,
              city: defaultAddress.city,
              provinceId: defaultAddress.provinceId,
              countryId: defaultAddress.countryId,
              zip: defaultAddress.zip,
            },
          });
        }
      }
    } else if (!defaultAddress?.id) {
      setSelectedAddressId(null);
      setIsEditable(true);
      form.setFieldsValue({
        [props.addressType]: {
          address1: defaultAddress?.address1,
          address2: defaultAddress?.address2,
          city: defaultAddress?.city,
          provinceId: defaultAddress?.provinceId,
          countryId: defaultAddress?.countryId,
          zip: defaultAddress?.zip,
        },
      });
    }
  }, [props.addressType]);

  useEffect(() => {
    if (hideEdit) {
      setIsAddressSectionVisible(false);
    }
  }, [hideEdit]);

  return (
    <Modal
      title={
        props.addressType == AddressType.BillingAddress.name ? (
          <FormattedMessage id="ClientDetails.BillingAddress" />
        ) : (
          <FormattedMessage id="ClientDetails.DeliveryAddress" />
        )
      }
      closable={{ "aria-label": "Custom Close Button" }}
      open={true}
      width={800}
      onCancel={props.onCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          <FormattedMessage id="Common.Cancel" />
        </Button>,
        <Button key="send" type="primary" onClick={() => handleUpdate()}>
          <FormattedMessage id="Common.Update" />
        </Button>,
      ]}
    >
      <Form
        form={form}
        name="basic"
        layout="vertical"
        autoComplete="off"
        size="large"
        preserve={true}
      >
        <Row gutter={16} align="middle">
          <Col xs={24} sm={isAddressSectionVisible ? 8 : 24}>
            <Radio.Group
              className="radiostyle"
              options={radioOptions}
              onChange={(e) => {
                setSelectedAddressId(e.target.value);
              }}
              value={selectedAddressId}
            />
          </Col>

          {/* <Col
            xs={24}
            sm={16}
            style={{
              display:
                partner && props.addressType === AddressType.BillingAddress.name
                  ? "none"
                  : "block",
            }}
          >
            <div className="text-right  mb-10">
              <Button
                color="primary"
                variant="outlined"
                onClick={() => handleEdit()}
              >
                <FormattedMessage id="Address.AddNewAddress" />
              </Button>
            </div>

            <div>
              <Address
                prefix={props?.addressType}
                disabled={!isEditable}
                setIsFieldsEdited={setIsFieldsEdited}
              />
            </div>
          </Col> */}

          <Col
            xs={24}
            sm={16}
            style={{
              display:
                (partner &&
                  props.addressType === AddressType.BillingAddress.name) ||
                hideEdit
                  ? "none"
                  : undefined,
            }}
          >
            <div className="text-right mb-10">
              <Button
                color="primary"
                variant="outlined"
                onClick={() => handleEdit()}
              >
                <FormattedMessage id="Address.AddNewAddress" />
              </Button>
            </div>

            <div>
              <Address
                prefix={props?.addressType}
                disabled={!isEditable}
                setIsFieldsEdited={setIsFieldsEdited}
                isValidationRequired={true}
              />
            </div>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

export default QuoteAddress;
